import Link from "next/link";
import { CalendarDays, MapPin, UserRound } from "lucide-react";

import {
  EVENT_LOCATION_LABELS,
  EVENT_TYPE_LABELS,
  formatEventWhen,
  type EventSummary,
} from "@/lib/events/types";
import { resolveEventCoverUrl } from "@/lib/events/covers";

export function EventPreviewCard({ event }: { event: EventSummary }) {
  const overlay =
    event.locationType === "online"
      ? "Online előadás"
      : EVENT_LOCATION_LABELS[event.locationType];

  return (
    <Link
      href={`/events/${event.slug}`}
      className="mt-3 block overflow-hidden rounded-2xl border bg-card transition-shadow hover:shadow-sm"
    >
      <div className="space-y-2 px-4 pt-4">
        <p className="text-base font-semibold leading-snug">{event.title}</p>
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          <CalendarDays className="size-4 text-primary" />
          {formatEventWhen(event.startsAt, event.timezone)}
        </p>
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          {event.locationType === "in_person" ? (
            <MapPin className="size-4 text-primary" />
          ) : (
            <UserRound className="size-4 text-primary" />
          )}
          {event.organizer?.fullName ??
            event.community?.name ??
            EVENT_TYPE_LABELS[event.eventType]}
        </p>
      </div>
      <div className="relative mt-3 h-48 bg-gradient-to-br from-primary/15 to-muted">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={resolveEventCoverUrl(event.coverUrl, event.slug, event.eventType)}
          alt=""
          className="size-full object-cover"
        />
        <span className="absolute bottom-3 left-3 rounded-md bg-black/55 px-2.5 py-1 text-xs font-medium text-white">
          {overlay}
        </span>
      </div>
    </Link>
  );
}
